<script lang="ts">
	interface Props {
		title?: string | null;
	}

	let { title = 'Saved' }: Props = $props();
</script>

<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="icon">
	{#if title}
		<title>{title}</title>
	{/if}
	<path
		d="M14 12.8C13.5 12.31 12.78 12 12 12C10.34 12 9 13.34 9 15C9 16.31 9.84 17.41 11 17.82C11.07 15.67 12.27 13.8 14 12.8M11.09 19H5V5H16.17L19 7.83V12.35C19.75 12.61 20.42 13 21 13.54V7L17 3H5C3.89 3 3 3.9 3 5V19C3 20.1 3.89 21 5 21H11.81C11.46 20.39 11.21 19.72 11.09 19M6 10H15V6H6V10M15.75 21L13 18L14.16 16.84L15.75 18.43L19.34 14.84L20.5 16.25L15.75 21"
	/>
</svg>

<style lang="scss">
	.icon {
		width: 1.5rem;
		fill: var(--svg-clr, hsl(var(--clr-on-surface-1)));
		transition: color 200ms;
	}
</style>
